import React from 'react';
import { Form } from 'react-final-form';

import validate from '../../../../utils/validate';
import UserFormInner from './UserFormInner';
import CommonModal from '../../../../components/common-modal/CommonModal';

const UserFormModal = ({ isOpen, user = {}, onSubmit, onClose, onCancel, formTitle, submitButtonText, validation }) => {
  const userFormInitialValues = {
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    username: user.username || '',
    password: user.password || '',
    // enabled: user.enabled || false,
    // isAdmin: user.isAdmin || false,
    assignedProjects: user.assignedProjects || [],
  };

  const handleSubmit = async (values) => {
    await onSubmit(values);
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={userFormInitialValues}
        onSubmit={handleSubmit}
        subscription={{ submitting: true, pristine: true, submitError: true }}
        validate={(values) => validate(values, validation())}
        render={({ handleSubmit }) => (
          <UserFormInner
            onSubmit={handleSubmit}
            onCancel={onCancel}
            formTitle={formTitle}
            submitButtonText={submitButtonText}
          />
        )}
      />
    </CommonModal>
  );
};

export default UserFormModal;
